import React, { useState, useEffect } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { User, CheckCircle, Trophy } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../config/api';
import './ProfilePage.css';

function ProfilePage() {
  const { user, loading: authLoading } = useAuth();
  const [solves, setSolves] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSolves() {
      if (!user) return;
      
      try {
        const data = await api.getSolves();
        setSolves(data.solves || []);
      } catch (err) {
        console.error('Error fetching solves:', err);
      } finally {
        setLoading(false);
      }
    }

    if (user) {
      fetchSolves();
    }
  }, [user]);

  if (authLoading) {
    return (
      <div className="container">
        <div className="loading-state">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="container">
      <div className="profile-page">
        <div className="profile-header">
          <div className="profile-avatar">
            {user.photoURL && user.photoURL.length > 0 ? (
              <img 
                src={user.photoURL} 
                alt={user.displayName}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
                referrerPolicy="no-referrer"
              />
            ) : (
              <User size={48} />
            )}
          </div>
          <div className="profile-info">
            <h1>{user.displayName}</h1>
            <p>{user.email}</p>
          </div>
        </div>

        <div className="profile-stats">
          <div className="stat-card">
            <Trophy size={32} />
            <div className="stat-value">{solves.length}</div>
            <div className="stat-label">Puzzles Solved</div>
          </div>
        </div>

        <div className="profile-section">
          <h2>Solved Puzzles</h2>
          
          {loading ? (
            <div className="loading-state">
              <div className="spinner" />
            </div>
          ) : solves.length === 0 ? (
            <div className="empty-solves">
              <p>You haven't solved any puzzles yet.</p>
              <Link to="/puzzles" className="btn btn-primary">
                Browse Puzzles
              </Link>
            </div>
          ) : (
            <div className="solves-list">
              {solves.map((solve) => (
                <Link 
                  key={solve.id} 
                  to={`/puzzles/${solve.slug}`}
                  className="solve-item"
                >
                  <CheckCircle size={20} className="solve-icon" />
                  <span className="solve-title">{solve.title}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
